<app-two-choices-control
  [title]="'P00061.installation.horloge' | translate"
  [firstLabel]="
    'P00039.lighting.functionality.parameters.setting.title.clock.day'
      | translate
  "
  [firstValue]="0"
  [secondLabel]="
    'P00039.lighting.functionality.parameters.setting.title.clock.week'
      | translate
  "
  [secondValue]="1"
  [value]="actionStack!.getValue('wpPTypeHorloge')"
  (onChange)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.PACWP_Parametrage1,
      'wpPTypeHorloge',
      $event
    );
    this.actionStack!.commit()
  "
>
</app-two-choices-control>

@if (this.actionStack!.getValue('wpPTypeHorloge') === 0) {
  <app-larged-link
    [name]="
      'P0003600.installation.filtration.programmePPH.horlogePicotsJoursPPH.programmeTitre'
        | translate
    "
    (onPress)="goToFunctionParametersSettingsClockScreen()"
  >
  </app-larged-link>
} @else {
  <app-larged-link
    [name]="
      'P0003600.installation.filtration.programmePPH.horlogePicotsJoursPPH.programmeTitre'
        | translate
    "
    (onPress)="goToFunctionParametersSettingClockWeekScreen()"
  >
  </app-larged-link>
}

<app-label-description
  [description]="'P00061.installation.horloge.description' | translate"
></app-label-description>

<app-label-configuration
  [title]="'P00061.installation.parampac.compresseur.title' | translate"
  [titleListe]="'P00061.installation.parampac.compresseur.value' | translate"
  [description]="
    'P00061.installation.parampac.compresseur.description' | translate
  "
  [value]="actionStack!.getValue('wpPFonctionnementCompresseur')"
  [liste]="P00061FonctionnementCompresseur"
  (onPress)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.PACWP_Parametrage1,
      'wpPFonctionnementCompresseur',
      $event
    );
    this.actionStack!.commit()
  "
>
</app-label-configuration>

<app-label-configuration
  [title]="'P00061.installation.parampac.silence.title' | translate"
  [description]="'P00061.installation.parampac.silence.description' | translate"
  [titleListe]="'P00061.installation.parampac.silence.value' | translate"
  [value]="actionStack!.getValue('wpPModeSilence')"
  [liste]="P00061ModeSilence"
  (onPress)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.PACWP_Parametrage1,
      'wpPModeSilence',
      $event
    );
    this.actionStack!.commit()
  "
>
</app-label-configuration>

<app-label-configuration
  [title]="'P00061.installation.parampac.fonctionnement.title' | translate"
  [titleListe]="'P00061.installation.parampac.fonctionnement.value' | translate"
  [description]="
    'P00061.installation.parampac.fonctionnement.description' | translate
  "
  [value]="actionStack!.getValue('wpPModeFonctionnementTemperature')"
  [liste]="P00061FonctionnementPAC"
  (onPress)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.PACWP_Parametrage1,
      'wpPModeFonctionnementTemperature',
      $event
    );
    this.actionStack!.commit()
  "
>
</app-label-configuration>

<app-switch-configuration
  [title]="
    'P00061.installation.paraminstallation.comportementFiltration.title'
      | translate
  "
  [nameCustom]="
    'P00061.installation.paraminstallation.comportementFiltration.value'
      | translate
  "
  [value]="actionStack!.getValue('wpIActivationFonctionPriorite') !== 0"
  [description]="
    'P00061.installation.paraminstallation.comportementFiltration.description'
      | translate
  "
  (onPress)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.PACWP_Installation,
      'wpIActivationFonctionPriorite',
      $event ? 1 : 0
    );
    this.actionStack!.commit()
  "
>
</app-switch-configuration>

<app-switch-configuration
  [title]="
    'P00061.installation.paraminstallation.autoMaintienFiltration.title'
      | translate
  "
  [nameCustom]="
    'P00061.installation.paraminstallation.autoMaintienFiltration.value'
      | translate
  "
  [value]="actionStack!.getValue('wpIActivationFonctionAutoMaintien') !== 0"
  [description]="
    'P00061.installation.paraminstallation.autoMaintienFiltration.description'
      | translate
  "
  (onPress)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.PACWP_Installation,
      'wpIActivationFonctionAutoMaintien',
      $event ? 1 : 0
    );
    this.actionStack!.commit()
  "
>
</app-switch-configuration>
